import { createReducer, on } from '@ngrx/store';
import { UserSettingsActions } from './user-settings.actions';
import { UserSettingsState, initialState } from './user-settings.state';

export const reducer = createReducer(
  initialState,
  on(UserSettingsActions.get_user_settings_start, (state: UserSettingsState) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserSettingsActions.get_user_settings_success, (state: UserSettingsState, data) => {
    return {
      ...state,
      loading: false,
      error: null,
      userSettings: data.userSettings
    };
  }),
  on(UserSettingsActions.get_user_settings_fail, (state: UserSettingsState, error) => ({
    ...state,
    loading: false,
    error,
    userSettings: null
  })),
  on(UserSettingsActions.set_user_settings_start, (state: UserSettingsState, action) => {
    return {
      ...state,
      loading: true,
      error: null
    };
  }),
  on(UserSettingsActions.set_user_language_start, (state: UserSettingsState, data) => {
    const userSettingsCopy = { ...state.userSettings };
    const updatedUserSettingsCopy = { ...userSettingsCopy, LanguageCode: data.languageCode };
    return {
      ...state,
      userSettings: updatedUserSettingsCopy,
      loading: true,
      error: null
    };
  }),
  on(UserSettingsActions.set_user_settings_success, UserSettingsActions.set_user_language_success, (state: UserSettingsState) => {
    return {
      ...state,
      loading: false,
      error: null
    };
  }),
  on(UserSettingsActions.set_user_settings_fail, UserSettingsActions.set_user_language_fail, (state: UserSettingsState, error) => ({
    ...state,
    loading: false,
    error
  }))
);
